import { CALL_API } from '../middleware/api'

export const REDEEMCODES_REQUEST = 'REDEEMCODES_REQUEST'
export const REDEEMCODES_SUCCESS = 'REDEEMCODES_SUCCESS'
export const REDEEMCODES_FAILURE = 'REDEEMCODES_FAILURE'

export function fetchRedeemCodes(customer) {
  const params = customer ? `?customer=${customer}` : '';
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `swap-code${params}`,
      authenticated: true,
      types: [REDEEMCODES_REQUEST, REDEEMCODES_SUCCESS, REDEEMCODES_FAILURE]
    }
  }
}

export const REDEEMCODE_REQUEST = 'REDEEMCODE_REQUEST'
export const REDEEMCODE_SUCCESS = 'REDEEMCODE_SUCCESS'
export const REDEEMCODE_FAILURE = 'REDEEMCODE_FAILURE'

export function fetchRedeemCode(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `swap-code/${id}`,
      authenticated: true,
      types: [REDEEMCODE_REQUEST, REDEEMCODE_SUCCESS, REDEEMCODE_FAILURE]
    }
  }
}

export const REDEEMCODE_ADD_REQUEST = 'REDEEMCODE_ADD_REQUEST'
export const REDEEMCODE_ADD_SUCCESS = 'REDEEMCODE_ADD_SUCCESS'
export const REDEEMCODE_ADD_FAILURE = 'REDEEMCODE_ADD_FAILURE'

export function addRedeemCode(redeemCode) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'swap-code',
      authenticated: true,
      body: JSON.stringify(redeemCode),
      types: [REDEEMCODE_ADD_REQUEST, REDEEMCODE_ADD_SUCCESS, REDEEMCODE_ADD_FAILURE]
    }
  }
}

export const REDEEMCODE_UPDATE_REQUEST = 'REDEEMCODE_UPDATE_REQUEST'
export const REDEEMCODE_UPDATE_SUCCESS = 'REDEEMCODE_UPDATE_SUCCESS'
export const REDEEMCODE_UPDATE_FAILURE = 'REDEEMCODE_UPDATE_FAILURE'

export function updateRedeemCode(id, redeemCode) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `swap-code/${id}`,
      authenticated: true,
      body: JSON.stringify(redeemCode),
      types: [REDEEMCODE_UPDATE_REQUEST, REDEEMCODE_UPDATE_SUCCESS, REDEEMCODE_UPDATE_FAILURE]
    }
  }
}

export const REDEEMCODE_DELETE_REQUEST = 'REDEEMCODE_DELETE_REQUEST'
export const REDEEMCODE_DELETE_SUCCESS = 'REDEEMCODE_DELETE_SUCCESS'
export const REDEEMCODE_DELETE_FAILURE = 'REDEEMCODE_DELETE_FAILURE'

export function deleteRedeemCode(id) {
  return {
    [CALL_API]: {
      method: 'DELETE',
      endpoint: `swap-code/${id}`,
      authenticated: true,
      types: [REDEEMCODE_DELETE_REQUEST, REDEEMCODE_DELETE_SUCCESS, REDEEMCODE_DELETE_FAILURE]
    }
  }
}